import React, { useState } from 'react';
import SacredImages from './SacredImages';
import TempleCommittee from './TempleCommittee';
import VazhibaduSevas from './VazhibaduSevas';

const Donations = () => {
  const [activeTab, setActiveTab] = useState('agrashaala');

  return (
    <section id="donations" className="section bg-gradient-to-b from-orange-50 to-yellow-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-saffron mb-4">
            Sevas and Donation
          </h2>
          <div className="decorative-border"></div>
        </div>

        {/* Sevas and Donation Tabs */}
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-center mb-8 space-y-2 md:space-y-0 md:space-x-4">
            <button
              onClick={() => setActiveTab('agrashaala')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                activeTab === 'agrashaala'
                  ? 'bg-saffron text-white shadow-lg'
                  : 'bg-gold text-saffron border-2 border-saffron hover:bg-saffron hover:text-white'
              }`}
              data-testid="agrashaala-tab"
            >
              <span className="text-xs block">Click here for</span>
              Agrashaala Renovation
            </button>
            <button
              onClick={() => setActiveTab('ehundi')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                activeTab === 'ehundi'
                  ? 'bg-saffron text-white shadow-lg'
                  : 'bg-gold text-saffron border-2 border-saffron hover:bg-saffron hover:text-white'
              }`}
              data-testid="ehundi-tab"
            >
              <span className="text-xs block">Click here for</span>
              E-Hundi (Sevas and General Donations)
            </button>
          </div>

          {/* Agrashaala Renovation Sevas and Donation */}
          {activeTab === 'agrashaala' && (
            <div className="card-temple" data-testid="agrashaala-section">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-saffron mb-4">
                    Punaprathishta Shatabdi Renovation Appeal
                  </h3>
                  <h4 className="text-xl font-semibold text-gray-800 mb-4">
                    Agrashaala Renovation Project
                  </h4>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Help us renovate and restore the sacred Agrashaala of our temple as part of 
                    our Punaprathishta Shatabdi celebrations. Your contribution will help preserve this holy space for 
                    future generations of devotees.
                  </p>
                  
                  {/* Bank Details */}
                  <div className="bg-gradient-to-r from-yellow-100 to-orange-100 p-4 rounded-lg mb-4">
                    <h5 className="font-semibold text-gray-800 mb-2">Bank Details:</h5>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p><strong>Account Name:</strong> SREE KRISHNASWAMY DEVASWOM</p>
                      <p><strong>Bank:</strong> BANK OF BARODA</p>
                      <p><strong>A/C:</strong> 62790200001260</p>
                      <p><strong>IFSC:</strong> BARB0VJKOGR</p>
                      <p className="text-xs text-gray-600">(Fifth character is zero)</p>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-4 rounded-lg mb-4">
                    <p className="text-sm text-gray-700 font-medium">
                      Kindly send a screenshot to <strong>9847103672</strong>, <strong>9400605057</strong>, 
                      or <strong>9497217336</strong> after donation payment.
                    </p>
                  </div>
                  
                  <div className="text-center">
                    <img
                      src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/9di8et4e_2.png"
                      alt="Agrashaala renovation appeal for Punaprathishta Centenary"
                      className="mx-auto max-w-full h-auto rounded-lg shadow-lg"
                    />
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="bg-white p-6 rounded-xl shadow-lg lotus-border">
                    <h5 className="font-semibold text-gray-800 mb-4">Scan the QR Code for donation</h5>
                    <img
                      src="https://customer-assets.emergentagent.com/job_temple-content/artifacts/ut3pjxtv_kindly%20send%20a%20screenshot%20to%209847103672%2C9497217336%2C9400605057_20251008_230305_0000.png"
                      alt="Agrashaala Renovation Sevas and Donation QR Code with Bank Details"
                      className="mx-auto max-w-full h-auto rounded-lg shadow-md"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* E-Hundi Sevas and General Donations */}
          {activeTab === 'ehundi' && (
            <div className="card-temple" data-testid="ehundi-section">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-saffron mb-4">
                    E-Hundi
                  </h3>
                  <h4 className="text-xl font-semibold text-gray-800 mb-4">
                    E-Hundi - Digital Offering
                  </h4>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Make your offerings digitally through our E-Hundi system.
                  </p>
                  
                  {/* Bank Details */}
                  <div className="bg-gradient-to-r from-yellow-100 to-orange-100 p-4 rounded-lg mb-4">
                    <h5 className="font-semibold text-gray-800 mb-2">Bank Details:</h5>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p><strong>Account Name:</strong> SREE KRISHNASWAMY DEVASWOM</p>
                      <p><strong>Bank:</strong> BANK OF BARODA</p>
                      <p><strong>A/C:</strong> 62790200001260</p>
                      <p><strong>IFSC:</strong> BARB0VJKOGR</p>
                      <p className="text-xs text-gray-600">(Fifth character is zero)</p>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 border-2 border-blue-300 p-4 rounded-lg mb-4">
                    <p className="text-sm text-gray-800 font-semibold">
                      📸 Kindly send a screenshot to 9447329435 from 6-11 AM and 5:30-8 PM in case of online payment for sevas.
                    </p>
                  </div>
                  
                  <div className="bg-green-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-700">
                      <strong>Temple Timings:</strong><br/>
                      Morning: 5:30 AM - 10:45 AM<br/>
                      Evening: 5:30 PM - 8:00 PM
                    </p>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="bg-white p-6 rounded-xl shadow-lg lotus-border">
                    <h5 className="font-semibold text-gray-800 mb-4">QR Code for E-Hundi</h5>
                    <img
                      src="https://customer-assets.emergentagent.com/job_03ddf0a8-3d37-4e4c-b32f-6eb8f7476ae1/artifacts/a7j8euhd_1000003710.png"
                      alt="E-Hundi Sevas and General Donations QR Code with decorative Hindu elements"
                      className="mx-auto max-w-full h-auto rounded-lg shadow-md"
                    />
                    <p className="text-sm text-gray-600 mt-4">
                      Scan with any UPI app for sevas and general donations
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <VazhibaduSevas />
        <SacredImages />
        <TempleCommittee />
      </div>
    </section>
  );
};

export default Donations;